module.exports = __webpack_public_path__ + "img/win_fast.820c752a.png";